// tslint:disable: max-line-length
import { FontFaceTheme } from '@medly-components/theme';

const proximaNova: FontFaceTheme = {
    fontFamily: 'Roboto',
    fontFaces: [
        {
            primarySrc: `local('Roboto Light'), local('OpenSans-Light'), url(/fonts/RobotoLight.ttf) format('truetype')`,
            secondarySrc: '',
            fontWeight: 300,
            fontStyle: 'normal',
            fontDisplay: 'auto'
        },
        {
            primarySrc: `local('Roboto Regular'), local('OpenSans'), url(/fonts/RobotoRegular.ttf) format('truetype')`,
            secondarySrc: '',
            fontWeight: 400,
            fontStyle: 'normal',
            fontDisplay: 'auto'
        },
        {
            primarySrc: `local('Roboto Semibold'), local('OpenSans-Semibold'), url(/fonts/RobotoMedium.ttf) format('truetype')`,
            secondarySrc: '',
            fontWeight: 500,
            fontStyle: 'normal',
            fontDisplay: 'auto'
        },
        {
            primarySrc: `local('Roboto Bold'), local('OpenSans-Bold'), url(/fonts/RobotoSemiBold.ttf) format('truetype')`,
            secondarySrc: '',
            fontWeight: 600,
            fontStyle: 'normal',
            fontDisplay: 'auto'
        },
        {
            primarySrc: `local('Roboto Extrabold'), local('OpenSans-Extrabold'), url(/fonts/RobotoBold.ttf) format('truetype')`,
            secondarySrc: '',
            fontWeight: 700,
            fontStyle: 'normal',
            fontDisplay: 'auto'
        }
    ]
};

const faces: FontFaceTheme[] = [proximaNova];

export default faces;
